<template>
  <div id="activityQuery" class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="label">{{ $t('newApp.BasicInfo.an') }}：</span>
          <div class="content">
            <el-input v-model="form.activityCode" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'activityCode')"
            />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="label">{{ $t('newApp.activityInfo.noa') }}：</span>
          <div class="content">
            <el-input v-model="form.activityName" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'activityName')"
            />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="label">{{ $t('newApp.activityInfo.toa') }}：</span>
          <div class="content">
            <el-select v-model="form.activityType" :placeholder="$t('general.ps')">
              <el-option v-for="item in activityTypeList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldKey"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="label">{{ $t('newApp.BasicInfo.Applicant') }}：</span>
          <div class="content">
            <el-input v-model="form.applyUserNameOrId" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'applyUserNameOrId')"
            />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('eventList.AppStatus') }}：</span>
          <div class="content">
            <el-select v-model="form.approvalStatus" clearable :placeholder="$t('general.ps')" @change="searchBtn">
              <el-option v-for="(item, index) in approvalStatusList" :key="index" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('newApp.BasicInfo.cs') }}：</span>
          <div class="content">
            <el-input v-model="form.salerNameOrId" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'salerNameOrId')"
            />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('eventList.AppDepa') }}：</span>
          <div class="content">
            <el-select v-model="form.applyUserDeptNameOrCode" filterable remote clearable reserve-keyword
                       :placeholder="$t('general.peak')" :remote-method="getApplyDeptList" :loading="applyLoading"
            >
              <el-option v-for="item in applyDeptList" :key="item.userId" :label="item.deptName"
                         :value="item.deptCode"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('newApp.Attribute.cad') }}：</span>
          <div class="content">
            <el-select v-model="form.expenseDeptNameOrCode" filterable remote clearable reserve-keyword
                       :placeholder="$t('general.peak')" :remote-method="getCostDeptList" :loading="applyLoading"
            >
              <el-option v-for="item in costDeptList" :key="item.userId" :label="item.deptName"
                         :value="item.deptCode"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.Attribute.toe') }}：</div>
          <div class="content">
            <el-select v-model="form.expenseTypeCode" :placeholder="$t('general.ps')" clearable>
              <el-option v-for="item in expenseTypeList" :key="item.expenseTypeCode" :label="item.expenseTypeName"
                         :value="item.expenseTypeCode"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-if="isBrandPromotion" v-show="searchOpenFlag">
          <div class="label">{{ $t('eventList.Ms') }}：</div>
          <div class="content">
            <el-select v-model="form.materialConfigStat" :placeholder="$t('general.ps')" clearable>
              <el-option v-for="item in materialStatusList" :key="item.val" :label="item.label" :value="item.val" />
            </el-select>
          </div>
        </el-col>
        <!-- 活动申请时间 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.Attribute.at') }}：</div>
          <div class="content">
            <el-date-picker
              v-model="form.applyTimeRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('general.StartTime')"
              :end-placeholder="$t('general.EndTime')"
              @change="handleApplyTimeChange"
            />
          </div>
        </el-col>
        <!-- 活动分类 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.coa') }}：</div>
          <div class="content">
            <el-select
              v-model="form.activityClassification"
              clearable
              :placeholder="$t('general.ps')"
              @change="searchBtn"
            >
              <el-option v-for="item in activityClassificationList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldKey" />
            </el-select>
          </div>
        </el-col>
        <!-- 总部活动 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.headquarterActivityName') }}：</div>
          <div class="content">
            <el-input v-model="form.hqActivityName" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <!-- 模板活动 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.templateActivityName') }}：</div>
          <div class="content">
            <el-input v-model="form.templateActivityName" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="onreset">{{ $t('btn.Reset') }}</el-button>
          <el-button type="primary" @click="searchBtn">{{ $t('btn.Search') }}</el-button>
        </div>
      </el-row>
      <div class="advancedSearchBtn">
        <span :class="searchOpenFlag ? 'open' : ''" @click="searchOpenFlag = !searchOpenFlag">
          <span>{{ searchOpenFlag ? $t('btn.CollspseS') : $t('btn.AdvancedS') }}</span>
          <i class="iconfont icon-rili4-icon" />
        </span>
      </div>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="exportExcel">{{ $t('btn.Export') }}</el-button>
      <el-button type="primary" @click="biJump">{{ $t('eventList.BIFind') }}</el-button>
    </div>
    <commonTable
      ref="activityTable"
      @handleSelectChange="handleTableSelectChange"
      @handleCheckBoxAll="handleTableCheckAllChange"
    />
    <!-- 审批流程 -->
    <approvalProcessDialog
      :activity-code="currentActivityCode"
      :approval-dialog-visible="approvalDialogVisible"
      @dialogCloseHandle="approvalCloseHandle"
    />
    <!-- 召回修改 -->
    <quickProceDialog
      :title="quickProceTitle"
      :quick-proce-dialog-visible="quickProceDialogVisible"
      :activity-code="currentActivityCode"
      @dialogCloseHandle="quickProceCloseHandle"
    />
    <!-- 活动评估 -->
    <assessmentDialog
      :activity-code="currentActivityCode"
      :assessment-dialog-visible="assessmentDialogVisible"
      @dialogCloseHandle="assessmentDialogClose"
      @handlerSuccess="assessmentSuccess"
    />
    <activityLevelDialog
      ref="activityLevelDialog"
      :activity-code="currentActivityCode"
      :activity-level-dialog-visible="activityLevelDialogVisible"
      @dialogCloseHandle="activityLevelDialogClose"
      @handlerSuccess="activityLevelSuccess"
    />

    <productPromotionLeadingDialog
      ref="productPromotionLeadingDialog"
      :activity-code="currentActivityCode"
      :product-promotion-leading-dialog-visible="productPromotionLeadingDialogVisible"
      @dialogCloseHandle="productPromotionLeadingDialogClose"
      @handlerSuccess="productPromotionLeadingSuccess"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import approvalProcessDialog from './component/activityQuery/approvalProcessDialog.vue';
import quickProceDialog from './component/activityQuery/quickProceDialog';
import assessmentDialog from './component/reportList/assessmentDialog';
import activityLevelDialog from './component/reportList/activityLevelDialog';
import productPromotionLeadingDialog from './component/reportList/productPromotionLeadingDialog';
import { activityQuery } from './service';
import { newApplicationFormApi } from '../newApplicationForm/service';
import { arrayQuery, isNotEmpty } from '@/utils/utils';
export default {
  name: 'ActivityQuery',
  components: {
    commonTable,
    approvalProcessDialog,
    quickProceDialog,
    assessmentDialog,
    activityLevelDialog,
    productPromotionLeadingDialog
  },
  data () {
    return {
      searchOpenFlag: false,
      approvalDialogVisible: false,
      activityLevelDialogVisible: false,
      productPromotionLeadingDialogVisible: false,
      form: {
        activityStatus: 1
      },
      tempForm: {
        activityStatus: 1
      },
      activityTypeList: [],
      applyDeptList: [],
      costDeptList: [],
      tableData: [],
      expenseTypeList: [],
      sexList: [
        {
          val: 'Man',
          label: this.$t('general.Man')
        },
        {
          val: 'Women',
          label: this.$t('general.Women')
        }
      ],
      materialStatusList: [
        {
          label: this.$t('eventList.Configured'),
          val: '1'
        },
        {
          label: this.$t('eventList.NotCon'),
          val: '0'
        }
      ],
      currentActivityCode: '',
      // applyKey: 'all',
      // expenseKey: 'all',
      applyLoading: false,
      isBrandPromotion: false,
      quickProceDialogVisible: false,
      quickProceTitle: '',
      approvalStatusList: [],
      activityLevelList: [],
      assessmentDialogVisible: false,
      lang: localStorage.getItem('lang') || 'zh-CN',
      canHaveImc: false,
      selectedRows: [],
      activityClassificationList: [] // 活动分类
    };
  },
  methods: {
    handleTableSelectChange (payload) {
      this.updateSelectedRows(payload);
    },
    handleTableCheckAllChange (payload) {
      this.updateSelectedRows(payload);
    },
    updateSelectedRows ({ records = [] }) {
      this.selectedRows = [...records];
    },
    handleApplyTimeChange (e) {
      if (e) {
        this.$set(this.form, 'startDate', e[0]);
        this.$set(this.form, 'endDate', e[1]);
      } else {
        this.$delete(this.form, 'startDate');
        this.$delete(this.form, 'endDate');
      }
    },
    exportExcel () {
      if (this.form.applyTimeRange) {
        delete this.form.applyTimeRange;
      }
      const params = JSON.parse(JSON.stringify(this.form));
      if (params.approvalStatus) {
        params.approvalStatus = arrayQuery(
          params.approvalStatus,
          this.approvalStatusList,
          'fieldValue'
        ).fieldKey;
      }
      const selectedRows = JSON.parse(JSON.stringify(this.selectedRows));
      if (isNotEmpty(selectedRows)) {
        selectedRows.forEach(item => {
          item = {
            ...item,
            ...item.marketActivity
          };
        });
        params.activityCodeList = selectedRows.map(item => item.marketActivity.activityCode);
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t('general.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      activityQuery.exportActivityList(params).then((res) => {
        loading.close();
        try {
          const arrayBuffer = res.data;
          const contentDisposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
          let fileName = '活动列表.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i);
            if (fileNameMatch) {
              fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
            }
          }
          const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
          this.$message.success(this.$t('general.ExportSuccess'));
        } catch (e) {
          this.$message.error(this.$t('general.ExportFailure'));
        }
      }).catch(() => {
        loading.close();
        this.$message.error(this.$t('general.ExportFailure'));
      });
    },
    assessmentSuccess () {
      this.assessmentDialogVisible = false;
      this.searchBtn();
    },
    assessmentHandler (row) {
      this.currentActivityCode = row.marketActivity.activityCode;
      this.assessmentDialogVisible = true;
    },
    assessmentDialogClose () {
      this.assessmentDialogVisible = false;
    },
    activityLevelHandler (row) {
      this.currentActivityCode = row.marketActivity.activityCode;
      this.$refs.activityLevelDialog.openDailg(true, row.marketActivity.activityLevel);
    },

    productPromotionLeadingHandler (row) {
      this.currentActivityCode = row.marketActivity.activityCode;
      this.$refs.productPromotionLeadingDialog.openDailg(true, row.marketActivity.productPromotionLeading);
    },
    activityLevelDialogClose () {
      this.$refs.activityLevelDialog.openDailg(false);
    },
    productPromotionLeadingDialogClose () {
      this.$refs.productPromotionLeadingDialog.openDailg(false);
    },
    activityLevelSuccess () {
      this.$refs.activityLevelDialog.openDailg(false);
      this.searchBtn();
    },

    productPromotionLeadingSuccess () {
      this.$refs.productPromotionLeadingDialog.openDailg(false);
      this.searchBtn();
    },

    biJump () {
      window.open('http://ruijiebi.ruijie.com.cn/webroot/decision?rjl=oa');
    },
    quickProcessingBtn (row, title) {
      this.quickProceTitle = title;
      this.currentActivityCode = row.marketActivity.activityCode;
      this.quickProceDialogVisible = true;
    },
    quickProceCloseHandle () {
      this.quickProceDialogVisible = false;
    },
    inputBoxFilter (val, key) {
      let numVal = val.replace(/^\s+|\s+$/g, '');
      this.$set(this.form, key, numVal);
    },
    // 搜索申请部门的选中事件
    applyChange () { },

    approvalStateBtn (row) {
      if (row.approveStatus === this.$t('home.pf')) {
        this.$router.push({
          path: '/activityDetails',
          query: {
            activityCode: row.marketActivity.activityCode,
            metaActive: '/activityQuery',
            activeName: 'ExecutionFeedback'
          }
        });
        return;
      }
      // 获取弹窗信息
      this.currentActivityCode = row.marketActivity.activityCode;
      // 打开审批流程弹窗
      this.approvalDialogVisible = true;
    },
    approvalCloseHandle () {
      this.approvalDialogVisible = false;
    },
    onreset () {
      this.form = { activityStatus: 1 };
      this.searchBtn();
    },
    searchBtn () {
      if (this.form.applyTimeRange) {
        delete this.form.applyTimeRange;
      }
      this.tempForm = JSON.parse(JSON.stringify(this.form));
      if (this.form.approvalStatus) {
        this.tempForm.approvalStatus = arrayQuery(
          this.form.approvalStatus,
          this.approvalStatusList,
          'fieldValue'
        ).fieldKey;
      }
      this.$refs.activityTable.pageData.pageNum = 1;
      this.$refs.activityTable.getTableData({
        url: '/activity/market_activity_list',
        params: this.tempForm
      });
    },
    detailsJump (row) {
      this.$router.push({
        path: '/activityDetails',
        query: {
          activityCode: row.marketActivity.activityCode,
          metaActive: '/activityQuery'
        }
      });
    },
    feedbackJump (row) {
      this.$router.push({
        path: '/activityDetails',
        query: {
          activityCode: row.marketActivity.activityCode,
          activeName: 'ExecutionFeedback'
        }
      });
    },
    addMerchantsJump (row) {
      this.$router.push({
        path: '/activityDetails',
        query: {
          activityCode: row.marketActivity.activityCode,
          activeName: 'travellingTrader'
        }
      });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._data('checkboxColumn')
          ._width('60')
          ._fixed('left')
          ._others('checkbox')
      );
      tableRow.push(
        new TableColumns()
          ._width('160')
          ._title(this.$t('eventList.ActCode'))
          ._fixed('left')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              const routeData = this.$router.resolve({
                path: '/activityDetails',
                query: {
                  activityCode: row.marketActivity.activityCode,
                  metaActive: '/activityQuery'
                }
              });
              return (
                <div>
                  <a class="btnText" href={routeData.href} onClick={(e) => { e.preventDefault(); this.detailsJump(row); }}>{row.marketActivity.activityCode}</a>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('14%')
          ._title(this.$t('newApp.activityInfo.noa'))
          ._data('marketActivity.activityName')
      );
      tableRow.push(
        new TableColumns()
          ._width('140')
          ._title(this.$t('eventList.Afc'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let text = this.$t('home.ea');
              switch (row.marketActivity.submitType) {
                case 'report_submit':
                  text = this.$t('home.aff');
                  break;
                case 'qd_submit':
                  text = this.$t('home.ca');
                  break;
                case 'quick_submit':
                  text = this.$t('home.qa');
                  break;
              }
              return <div>{text}</div>;
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('12%')
          ._title(this.$t('newApp.activityInfo.toa'))
          ._data('marketActivity.activityType')
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('newApp.BasicInfo.Applicant'))
          ._data('marketActivity.applyUserName')
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('newApp.BasicInfo.cs'))
          ._data('marketActivity.salerName')
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('eventList.Department'))
          ._data('marketActivity.salerDeptName')
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('newApp.activityInfo.ps'))
          ._data('brandPromotionSupport')
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('newApp.BasicInfo.at'))
          ._data('marketActivity.applyTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(
                row.marketActivity.applyTime.replace(/-/g, '/')
              ).format('yyyy-MM-dd');
              return <span>{date}</span>;
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.Me'))
          ._data('marketActivity.totalCost')
          ._align('right')
      );
      tableRow.push(
        new TableColumns()
          ._width('12%')
          ._title(this.$t('eventList.QC'))
          ._data('approveName')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let approveName = '';
              if (row.approvers) {
                approveName = row.approvers
                  .map(item => {
                    return item.userName;
                  })
                  .join(',');
              }
              return (
                <div>
                  <span>{approveName}</span>
                </div>
              );
            }
          })
      );
      if (this.isBrandPromotion) {
        tableRow.push(
          new TableColumns()
            ._width('8%')
            ._title(this.$t('eventList.Ms'))
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                let text = row.marketActivity.materialConfigStat
                  ? this.$t('eventList.Configured')
                  : this.$t('eventList.NotCon');
                return <div>{text}</div>;
              }
            })
        );
      }
      if (this.lang === 'zh-CN') {
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('newApp.activityInfo.csl'))
            ._cellType('customDom')
            ._data('marketActivity.activityLevel')
            ._cellData({
              formater: ({ row, column }) => {
                let text = row.activityLevel;
                if (this.lang === 'zh-CN') {
                  if (row.marketActivity.activityLevel) {
                    text = arrayQuery(row.marketActivity.activityLevel, this.activityLevelList, 'fieldKey').fieldValue;
                    if (text === undefined) {
                      text = '-';
                    }
                  } else {
                    text = '-';
                  }
                }
                return (
                  this.lang === 'zh-CN'
                    ? <div>
                      {this.canHaveImc ? (<el-button type="text" onClick={() => { this.activityLevelHandler(row); }}>{{ text }}</el-button>) : { text }}
                    </div> : <div>-</div>
                );
              }
            })
          // ._cellData({
          //   formater: ({ row, column }) => {
          //     let text = row.activityLevel;
          //      if(this.lang==='zh-CN'){
          //         if (row.marketActivity.activityLevel) {
          //           text = arrayQuery(row.marketActivity.activityLevel, this.activityLevelList, 'fieldKey')?.fieldValue;
          //           if(text===undefined){
          //               text='-';
          //           }
          //         }else{
          //           text='-';
          //         }
          //     }
          //     return (
          //       this.lang==='zh-CN'?
          //       <div>
          //       <el-button type="text" onClick={() => { this.activityLevelHandler(row); }}>{{text}}</el-button>
          //       </div> : <div>-</div>

          //     );
          //   }
          // })
        );
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('newApp.BasicInfo.ppl'))
            ._cellType('customDom')
            ._data('marketActivity.productPromotionLeading')
            ._cellData({
              formater: ({ row, column }) => {
                let text = row.marketActivity.productPromotionLeading;
                if (text === null) {
                  text = '否';
                }
                return (
                  <div>
                    <el-button type="text" onClick={() => { this.productPromotionLeadingHandler(row); }}>{{ text }}</el-button>
                  </div>

                );
              }
            })
        );
      }
      tableRow.push(
        new TableColumns()
          ._width('12%')
          ._title(this.$t('eventList.Doi'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  {row.importance
                    ? row.importance
                    : this.$t('eventList.NotEva')}
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('eventList.Feasibility'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  {row.enforceability
                    ? row.enforceability
                    : this.$t('eventList.NotEva')}
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.Sos'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  {row.supportStrength
                    ? row.supportStrength
                    : this.$t('eventList.NotEva')}
                </div>
              );
            }
          })
      );
      // 审批状态列
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.AppStatus'))
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let text = this.form.approvalStatus
                ? this.form.approvalStatus
                : row.approveStatus;
              return (
                <div>
                  <el-button
                    type="text"
                    onClick={() => {
                      this.approvalStateBtn(row);
                    }}
                  >
                    {text}
                  </el-button>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('210')
          ._title(this.$t('general.Operation'))
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let userInfo = this.$store.state.userInfo;
              // 召回修改：当费用归属只有一条的时候才可以召回
              return (
                <div>
                  <el-button
                    type="text"
                    onClick={() => {
                      this.quickProcessingBtn(row, this.$t('eventList.Revoke'));
                    }}
                  >
                    {this.$t('eventList.Revoke')}
                  </el-button>
                  <el-button
                    type="text"
                    onClick={() => {
                      this.quickProcessingBtn(row, this.$t('eventList.Rc'));
                    }}
                  >
                    {this.$t('eventList.Rc')}
                  </el-button>
                  {userInfo.sysUser.deptCode &&
                    userInfo.sysUser.deptCode.indexOf('000013') === 0 ? (
                    <el-button
                      type="text"
                      onClick={() => {
                        this.assessmentHandler(row);
                      }}
                    >
                      {this.$t('btn.ActivityE')}
                    </el-button>
                  ) : null}
                </div>
              );
            }
          })
      );
      // tableRow.push(
      //   new TableColumns()
      //     ._width('200')
      //     ._title('操作')
      //     ._fixed('right')
      //     ._offOverFlow('ellipsis')
      //     ._cellType('customDom')
      //     ._cellData({
      //       formater: ({ row, column }) => {
      //         if (row.approveStatus === '待核销') {
      //           return (
      //             <div>
      //               <el-button type="text" onClick={() => { this.feedbackJump(row); }}>执行反馈</el-button>
      //               <el-button type="text" onClick={() => { this.addMerchantsJump(row); }}>录入客商</el-button>
      //             </div>
      //           );
      //         }
      //       }
      //     })
      // );
      let column = tableRow._cols();
      this.$refs.activityTable.setColumn(column, {
        resizable: true
      });
      this.$refs.activityTable.loadTable({
        url: '/activity/market_activity_list',
        listKey: 'searchMiddleDTOs',
        params: { activityStatus: 1 }
      });
    },
    getActivityCommonList () {
      let params = [
        'activity_level',
        'activity_type',
        'activity_classification',
        'apply_approval_status'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.activityLevelList = res.data.activity_level;
          this.activityTypeList = res.data.activity_type;
          this.activityClassificationList = res.data.activity_classification;
          this.approvalStatusList = res.data.apply_approval_status;
        }
      });
    },
    getApplyDeptList (applyKey) {
      if (applyKey && applyKey.indexOf(' ') === 0) {
        this.applyDeptList = [];
        return;
      }
      applyKey = applyKey || 'all';
      let params = {
        type: 'APPLAY',
        key: applyKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.applyDeptList = res.data;
        }
      });
    },
    getCostDeptList (expenseKey) {
      if (expenseKey && expenseKey.indexOf(' ') === 0) {
        this.costDeptList = [];
        return;
      }
      expenseKey = expenseKey || 'all';
      let params = {
        type: 'EXPENSE',
        key: expenseKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.costDeptList = res.data;
        }
      });
    },
    getExpenseTypeList () {
      activityQuery.getExpenseTypeList().then(res => {
        if (res.status === '200') {
          this.expenseTypeList = res.data;
        }
      });
    }
  },
  activated () {
    this.$refs.activityTable.getTableData({
      url: '/activity/market_activity_list',
      params: this.tempForm
    });
  },
  mounted () {
    newApplicationFormApi.checkUserIsImc().then(res => {
      this.canHaveImc = res.data;
    });
    this.isBrandPromotion = this.$store.state.userInfo.belongToBrandPromotionDept;
    this.loadTable();
    this.getActivityCommonList();
    this.getApplyDeptList();
    this.getCostDeptList();
    this.getExpenseTypeList();
  }
};
</script>

<style scoped></style>
